import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BarChart2, BookOpen, ClipboardList } from 'lucide-react';

const NAV_ITEMS = [
  { to: '/', label: 'Self Learning', icon: BookOpen, id: 'self-learning' },
  { to: '/activity', label: 'Your Activity', icon: ClipboardList, id: 'activity' },
  { to: '/performance', label: 'Performance', icon: BarChart2, id: 'performance' }
];

const ACTIVE_COLOR = '#3B82F6';
const INACTIVE_COLOR = '#9CA3AF';

function isItemActive(id, pathname) {
  if (id === 'activity') return pathname.startsWith('/activity');
  if (id === 'performance') return pathname.startsWith('/performance');
  return !pathname.startsWith('/activity') && !pathname.startsWith('/performance');
}

export default function SideNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <nav className="hidden h-full flex-col items-center justify-center gap-1 border-r border-[#E5E7EB] bg-white md:flex">
        {NAV_ITEMS.map(({ to, label, icon: Icon, id }) => {
          const active = isItemActive(id, pathname);
          const color = active ? ACTIVE_COLOR : INACTIVE_COLOR;
          return (
            <button
              key={id}
              type="button"
              onClick={() => navigate(to)}
              className="flex w-[72px] flex-col items-center gap-1.5 rounded-xl py-3 transition-all"
              style={{ color }}
            >
              <Icon className="h-5 w-5" strokeWidth={active ? 2.3 : 1.8} />
              <span className="text-center text-[10px] font-semibold leading-tight">{label}</span>
            </button>
          );
        })}
      </nav>

      <nav className="flex h-full items-stretch bg-white md:hidden">
        {NAV_ITEMS.map(({ to, label, icon: Icon, id }) => {
          const active = isItemActive(id, pathname);
          const color = active ? ACTIVE_COLOR : INACTIVE_COLOR;
          return (
            <button
              key={id}
              type="button"
              onClick={() => navigate(to)}
              className="flex flex-1 flex-col items-center justify-center gap-1 py-2 transition-colors"
              style={{ color }}
              aria-current={active ? 'page' : undefined}
            >
              <Icon className="h-6 w-6" strokeWidth={active ? 2.3 : 1.8} />
              <span className="text-xs font-semibold">{label}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
}
